const csv = require("csvtojson");
angular.module('leanlaw').controller('ImportCtrl', ['$scope', '$rootScope', '$q', '$window', "$timeout", '$location', '$stateParams', '$state', 'leanLawApi', 'clientMatterManager', 'expenseManager', 'exportJson', 'userService', function ($scope, $rootScope, $q, $window, $timeout, $location, $stateParams, $state, leanLawApi, clientMatterManager, expenseManager, exportJson, userService) {
  $scope.uploadedObjectArray;
  $scope.wasObjectUploaded = false;
  $scope.validationError = null;
  $scope.isUploading = false;
  $scope.showPreview = false;
  $scope.doneImporting = false;
  $scope.combinedExpenses = [];
  $scope.completed = 0;
  let filteredMatters = [];
  userService.me().then(me => {
    $scope.me = me;
  });
  clientMatterManager.listMatters({
    scope: "all"
  }).then(matters => {
    filteredMatters = matters.filter(m => m.hasOwnProperty("reference"));
  });
  $scope.uploadFile = function () {
    $scope.validationError = null;

    // Read file from upload field
    const f = document.getElementById("csvfile").files[0];
    const r = new FileReader();
    $scope.loading = true;
    // Fires once the file's text has been read
    r.onloadend = function (e) {
      csvToJson((e.target.result || "").trim()).then(obj => {
        console.log("Parsed csv -> json array:", obj);
        $scope.$apply(() => {
          $scope.uploadedObjectArray = obj;
          $scope.wasObjectUploaded = true;
          $scope.validationError = validate();
          $scope.loading = false;
        });
      });
    };

    // There are other methods to load as array buffers/binary string/dataURL
    r.readAsText(f);
  };
  $scope.getHeaders = function () {
    return $scope.getKeys($scope.uploadedObjectArray[0]);
  };

  // Returns keys for header with hidden fields filtered out
  $scope.getKeys = function (obj) {
    return Object.keys(obj).filter(k => k != "$$hashKey");
  };
  const altKeys = {
    'clientnickname1': 'id'
  };
  const requiredKeys = ["id", "date", "description", "amount"];

  // Returns whether a certain cell is invalid given its position in a row
  $scope.isInvalid = function (col, row, colIndex) {
    if (!col) return true;
    const rowName = Object.keys(row)[colIndex].trim().toLowerCase();
    // Check if date is string and it parses
    if (rowName == 'date' && isNaN(new Date(col))) return true;
    // Check if column has a value
    if (col.trim().length == 0) return true;
    // Check if id matches with any matter
    if (rowName.toLowerCase() == "id" || altKeys[rowName.toLowerCase()] == 'id') {
      return !filteredMatters.some(m => m.reference == col);
    }
    return false;
  };
  $scope.isValid = function (col, row, colIndex) {
    if ($scope.isInvalid(col, row, colIndex)) return false;
    const rowName = Object.keys(row)[colIndex].trim().toLowerCase();
    return requiredKeys.includes(altKeys[rowName] || rowName);
  };
  function validate() {
    let keysValid = true;
    // marks unused columsn as ignroed and check that required columns are there
    $scope.uploadedObjectArray.forEach(line => {
      const keys = Object.keys(line).map(key => {
        const mapped = (altKeys[key.toLowerCase()] || key).toLowerCase();
        const included = requiredKeys.includes(mapped);
        return {
          key,
          mapped,
          ignore: !included
        };
      });
      const hasRequired = requiredKeys.every(req => keys.find(k => k.mapped === req));
      if (!hasRequired) {
        keysValid = false;
      }
    });
    console.log($scope.uploadedObjectArray);
    if (!keysValid) {
      return `You're missing the required columns. Be sure that your\
          csv includes a header row at the top of the file, and that there are \
          no empty fields.`;
    }
    const keysNotNull = $scope.uploadedObjectArray.every(uo => {
      const keys = Object.keys(uo);
      return keys.every(k => uo[k] != null && uo[k] !== "");
    });
    if (!keysNotNull) {
      return `You're missing at least one field in your import. Double check\
          that your data is complete.`;
    }
    const idsMatch = $scope.uploadedObjectArray.every(uo => filteredMatters.some(m => m.reference === uo.id || m.reference === uo.ClientNickname1));
    if (!idsMatch) {
      return `At least one of the expense ids doesn't correspond to an\
          existing matter. See below for details.`;
    }

    // Used when checking for disabled submit
    return null;
  }

  // Returns promise with object
  function csvToJson(src) {
    return csv().fromString(src);
  }
  $scope.isDate = function (d) {
    // Check for Date instance because a number instead could be considered a date
    if (d instanceof Date) return true;
    // return !isNaN(new Date(d));
    return false;
  };
  $scope.combineChanged = function (combine) {
    $scope.combining = true;
    processExpenses(combine);
    $scope.combining = false;
  };
  $scope.next = function () {
    $scope.combine = true;
    processExpenses(true);
    $scope.showPreview = true;
  };
  function processExpenses(combine) {
    if (!combine) {
      $scope.combinedExpenses = $scope.uploadedObjectArray.map(row => cleanExpense(row));
      return;
    }
    $scope.combinedExpenses = $scope.uploadedObjectArray.reduce((accum, row) => {
      // Preprocess/coerce data coming in
      // Amount is initialy a string
      const clean = cleanExpense(row);
      clean.group = `${clean.date.toNetworkDate().substring(0, 7)}|${clean.matter.id}`;
      let idx = accum.findIndex(r => r.group === clean.group);
      if (idx === -1) {
        accum.push(clean);
        idx = accum.length - 1;
      } else {
        const addto = accum[idx];
        addto.amount += clean.amount;
        if (addto.date < clean.date) {
          addto.date = clean.date;
        }
        if (addto.description.indexOf(clean.description) === -1) {
          addto.description = `${addto.description}; ${clean.description}`;
        }
      }
      return accum;
    }, []);

    // Add month to expenses
    $scope.combinedExpenses.forEach(e => {
      const month = e.date.toLocaleString('en-us', {
        month: 'long'
      });
      // We are hardcoding the description here as opposed to taking the descriptions
      // that came along with the import. This is for Sinas. If other clients need
      // this we are likely to want to make this configurable
      // such that either we use the imported descriptions or we hard-code it based
      // on a company setting.
      e.description = `${month} Photocopies, Facsimiles, Postage, and Long Distance`;
    });
  }
  function cleanExpense(row) {
    return {
      date: new Date(row.date || row.Date),
      amount: +(row.amount || row.Amount),
      description: row.description || row.Description,
      matter: filteredMatters.find(f => f.reference === row.id || f.reference === row.ClientNickname1)
    };
  }

  // Begin the import process after the data has been consolidated
  $scope.import = function () {
    $scope.isUploading = true;
    // Add matter references here that would have otherwise been visible in the preview table
    console.log("Combined expenses", $scope.combinedExpenses);
    const throttleTime = 50;

    // Execute create sequentially with a throttle
    $scope.combinedExpenses.reduce((prev, expense) => {
      return prev.then(() => {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            expenseManager.create(expense.matter, expense, true).then(e => {
              $scope.completed++;
              $scope.percentage = 100 * $scope.completed / $scope.combinedExpenses.length;
              resolve();
            });
          }, throttleTime);
        });
      });
    }, Promise.resolve()).then(() => {
      $scope.doneImporting = true;
    });
  };
  $scope.finish = function () {
    $state.go("expenses");
  };
  $scope.export = function () {
    const request = {
      scope: "all"
    };
    let exp = [];
    clientMatterManager.listMatters(request).then(list => {
      list.forEach(m => {
        exp.push({
          name: m.reference,
          description: m.name
        });
      });

      // Dedup
      exp = exp.filter((matter, index, self) => index === self.findIndex(e => e.name == matter.name && e.description == matter.description));
      exportJson.downloadCsv(exp, "leanlaw-export", false);
    });
  };
}]);